import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ORG_TABS, OrganizationDetailPage } from "@/features/organizations/organization-detail-page";

export const Route = createFileRoute("/_authenticated/organizations/$organizationId/")({
  validateSearch: z.object({ tab: z.enum(ORG_TABS).optional().catch(undefined) }),
  head: () => ({ meta: [{ title: "Organization · Rogue Admin" }] }),
  component: OrganizationDetailPage,
});
